// @ts-strict-ignore
import {isValidEmailAddress} from 'common/util/string';

export const ErrorMessage = {
  requiredValidationErrors: {
    agreedToTermsOfUse: `Agreement is required for signup. `,
    company: `Need a company name. `,
    email: `Email address is required. `,
    name: `Full name is required. `,
    password: `Password is required. `,
    numberOfEmployees: `Number of employees is required.`,
    numberOfMaus: `Number of MAUs is required.`,
    department: `Department is required.`,
  },
  lengthValidationErrors: {
    name: `Name needs to be less than 30 characters. `,
    password: `Password has to be at least 8 characters and less than 64 characters. `,
  },
  formatValidationError: {
    email: `Please enter a valid email address`,
  },
  noError: ``,
};

export function requiredValidation(fieldName, fieldValue): string {
  if (!fieldValue) {
    return ErrorMessage.requiredValidationErrors[fieldName];
  }
  return ErrorMessage.noError;
}

export function nameLengthValidation(fieldName, fieldValue): string {
  if (fieldValue.length > 30) {
    return ErrorMessage.lengthValidationErrors[fieldName];
  }
  return ErrorMessage.noError;
}

export function passwordLengthValidation(fieldName, fieldValue): string {
  if (fieldValue.length < 8 || fieldValue.length > 64) {
    return ErrorMessage.lengthValidationErrors[fieldName];
  }
  return ErrorMessage.noError;
}

export function emailFormatValidation(fieldName, fieldValue): string {
  if (isValidEmailAddress(fieldValue)) {
    return ErrorMessage.noError;
  }
  return ErrorMessage.formatValidationError[fieldName];
}

export const validationRules = {
  agreedToTermsOfUse: [requiredValidation],
  company: [requiredValidation],
  email: [requiredValidation, emailFormatValidation],
  name: [requiredValidation, nameLengthValidation],
  password: [requiredValidation, passwordLengthValidation],
  department: [requiredValidation],
  numberOfEmployees: [requiredValidation],
  numberOfMaus: [requiredValidation],
};
